const $privateApi = useNuxtApp().$privateApi;
const config = useRuntimeConfig();
const host = config.public.baseURL;

export const _api = {
  module: {
    index: "/module/",
  },
  actions: {
    index: "action",
  },
  user: {
    index: "api/bo/user",
    create: "/api/bo/user/new",
    update: "api/bo/user",
    delete: "/api/bo/user/",
    userByid: "/api/bo/user/",
    userNotActive: "api/bo/user/notActive?",
    status: "status-customer",
    changecentre: "api/bo/auth/changecentre/",
  },
  role: {
    index: "role",
    create: "role",
    sanspopulate: "/role/sanspopulate",
    delete: "role/",
  },
  function: {
    index: "/api/bo/fonction",
  },
  affectationCentre: {
    centre: "usercentre/",
  },
  centre: "/centre",
  services: "/services",
  menu: "/menu/",
  adherentTracker: {
    numberOfConnections: "/api/adherent-tracker/number-of-connections",
    numberOfFirstConnections:
      "/api/adherent-tracker/number-of-first-connections",
    groups: "/adherent-tracker/groups",
    adherents: "/adherent-tracker/adherents",
    connectionHistory: "/api/adherent-tracker/connection-history",
    connectionHistoryExport:
      "/api/adherent-tracker/connection-history/export",
    avgSessionDuration: "/api/adherent-tracker/avg-session-duration",
    avgSessionDurationExport: "/api/adherent-tracker/avg-session-duration/export",
    globalAvgSessionDuration:
      "/api/adherent-tracker/global-avg-session-duration",
    requestsByAdUsers: "/api/adherent-tracker/requests-by-ad-users",
    requestsByAdUsersExport:
      "/api/adherent-tracker/requests-by-ad-users/export",
    topFeatures: "/api/adherent-tracker/top-features",
    featureActivities: "/api/adherent-tracker/feature-activities",
    featureActivitiesExport: "/api/adherent-tracker/feature-activities/export",
    exportAll: "/api/adherent-tracker/export-all",
  },
};
